import React, {
  DetailedHTMLProps,
  ReactNode,
  TextareaHTMLAttributes,
} from 'react'
import { useFormContext } from 'react-hook-form'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons'
import TextareaWithFloatingLabel from '@/features/quiz/textarea-with-floating-label'

type QuizTextareaInputProps = {
  name: string
  label: string
  hasError?: boolean
  contentAtEnd?: ReactNode
} & DetailedHTMLProps<
  TextareaHTMLAttributes<HTMLTextAreaElement>,
  HTMLTextAreaElement
>

export default function QuizTextareaInput({
  name,
  label,
  hasError,
  contentAtEnd,

  ...props
}: QuizTextareaInputProps) {
  const { register, watch, formState } = useFormContext()
  const value = watch(name)
  const field = register(name)
  const { isSubmitting, errors, touchedFields } = formState
  const touched = touchedFields?.[name]
  const error = errors[name]
  const isDisabled = isSubmitting || props.disabled

  return (
    <div>
      <TextareaWithFloatingLabel
        name={name}
        label={label}
        contentAtEnd={contentAtEnd}
        disabled={isDisabled}
        hasError={(touched && error) || hasError}
        value={value}
        field={field}
        {...props}
      />

      {touched && error && (
        <div className="relative mt-1 block pl-4 text-sm text-red-600">
          <FontAwesomeIcon icon={faCircleExclamation} className="mr-1.5" />
          {`${error.message}`}
        </div>
      )}
    </div>
  )
}
